import React, { useEffect, useState } from "react";
import axios from "axios";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Subscription_Fee() {
    const history = useHistory();
    const { token } = isAutheticated();

    const [payments, setPayments] = useState([]);
    const [filters, setFilters] = useState({ month: "" });

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(15); // backend limit = 15
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    // ----------------------------------------------------
    // 👉 View Invoice Page
    // ----------------------------------------------------
    const handleViewInvoice = (payment) => {
        history.push(`/invoice/${payment._id}`);
    };

    // ----------------------------------------------------
    // 👉 Fetch Subscription Invoices
    // ----------------------------------------------------
    const fetchInvoices = async (page = 1) => {
        try {
            setLoading(true);

            const params = {
                page,
                limit: rowsPerPage,
                ...filters,

                // Backend को सभी invoices भेजना है
                id: "all",
                invoiceFor: "all",
            };

            const res = await axios.get(`${API}/api/invoices/subscription_Invoices`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (res.data.success) {
                setPayments(res.data.invoices || []);
                setTotalPages(res.data.pages || 1);
            }
        } catch (err) {
            console.error("Error fetching invoices:", err);
        } finally {
            setLoading(false);
        }
    };

    // ----------------------------------------------------
    // 👉 Fetch whenever page OR filter changes
    // ----------------------------------------------------
    useEffect(() => {
        fetchInvoices(currentPage);
    }, [currentPage, filters]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
        setCurrentPage(1); // Reset to page 1
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* <div className="container"> */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Billing - Subscription Fees</h4>

                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">SoComOTT</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            Billing - Subscription Fees
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <h2 className="mb-4">Subscription Fees</h2> */}
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-body'>
                                {/* ---------------- TABLE ---------------- */}
                                {/* <table className="table table-bordered table-striped"> */}
                                <table className='table table-centered table-nowrap mb-2'>
                                    <thead className='thead-light'>
                                        {/* <thead className="thead-dark"> */}
                                        <tr className="text-center">
                                            <th>#</th>
                                            <th>Channel</th>
                                            <th>Type</th>
                                            <th>Invoice No</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        {loading ? (
                                            <tr>
                                                <td colSpan="8" className="text-center py-4">
                                                    <strong>Loading invoices...</strong>
                                                </td>
                                            </tr>
                                        ) : payments.length > 0 ? (
                                            payments.map((p, idx) => (
                                                <tr key={p._id}>
                                                    <td className="text-center">
                                                        {(currentPage - 1) * rowsPerPage + idx + 1}
                                                    </td>

                                                    <td className="text-center">
                                                        {p.invoiceFor === "channel"
                                                            ? p.subchannelName
                                                            : p.network_channelName}
                                                    </td>

                                                    <td className="text-center">
                                                        {p.invoiceFor === "channel" ? "Channel" : "Net. Channel"}
                                                    </td>

                                                    <td className="text-center">{p.invoiceNumber}</td>

                                                    <td className="text-center">
                                                        {new Date(p.createdAt).toLocaleDateString("en-US", {
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                        })}
                                                    </td>

                                                    <td className="text-center">${p.amount}</td>

                                                    <td className="text-center">
                                                        <span className={`badge ${p.status === "paid" ? "bg-success" : "bg-warning"
                                                            }`}>
                                                            {p.status}
                                                        </span>
                                                    </td>

                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            onClick={() => handleViewInvoice(p)}
                                                        >
                                                            View Invoice
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center py-3">
                                                    No invoices found.
                                                </td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>

                                {/* ---------------- PAGINATION ---------------- */}
                                {totalPages > 1 && !loading && (
                                    <nav>
                                        <ul className="pagination justify-content-center">

                                            {[...Array(totalPages)].map((_, i) => (
                                                <li
                                                    key={i}
                                                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                </li>
                                            ))}

                                        </ul>
                                    </nav>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
            </div>
        </div>
    );
}
